import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ed832d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Giới thiệu")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Giới thiệu")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Lịch sử"),
  /*#__PURE__*/_createElementVNode("p", null, "Trước năm 1975, vùng này thuộc thị xã Buôn Ma Thuột, tỉnh Đắk Lắk, chỉ có ba buôn người Êđê là Buôn Trấp nằm gần sát bờ Sông Serepôk, sau này gọi là sông Krông Ana, 2 buôn còn lại là Ê Căm và Rung nằm gần nhau."),
  /*#__PURE__*/_createElementVNode("p", null, "Ngày 5 năm 3 năm 1977, theo quyết định số 14/TC Ủy ban nhân dân cách mạng lâm thời tỉnh Đắk Lắk về điều chỉnh địa giới và thành lập 3 xã mới của thị xã Buôn Ma Thuột, thành lập các xã Ea Bông, Ea Na và Quảng Điền. Địa bàn thị trấn hiện nay thuộc xã Ea Bông."),
  /*#__PURE__*/_createElementVNode("p", null, "Ngày 19 tháng 9 năm 1981, Hội đồng Bộ trưởng ban hành Quyết định số 75/HĐBT về việc phân vạch địa giới của huyện và thị xã Buôn Ma Thuột, thành lập huyện Krông Ana. Địa bàn thị trấn vẫn thuộc xã Ea Bông thuộc huyện Krông Ana."),
  /*#__PURE__*/_createElementVNode("p", null, "Ngày 6 tháng 3 năm 1984, theo Quyết định số 35-QĐ/HĐBT của Hội đồng bộ trưởng, tách xã Ea Bông thành 3 đơn vị hành chính: xã Ea Bông, xã Dur Kmăl và thị trấn Buôn Trấp."),
  /*#__PURE__*/_createElementVNode("p", null, "Địa bàn thị trấn mới gồm 3 buôn trước đó đến thời điểm trước và sau với chính sách di cư đi kinh tế mới, dân cư đến lập nghiệp ở đây, đầu tiên là người trong tỉnh như người dân tộc Mường ở khu Hòa Bình thuộc xã Hòa Thắng, thị xã Buôn Ma Thuột đến định cư gần sông làm lúa nước, thành lập thôn Phú Đức. Những người gốc Huế từ vùng Đạt Lý (nay thuộc xã Hòa Thuận), thị xã Buôn Ma Thuột di cư đến gần bờ hồ (nay là Hồ Sen), thành lập thôn Đạt Lý. Người di cư từ miền Bắc định cư đầu tiên chủ yếu đến từ tỉnh Thái Bình, thành lập thôn Quỳnh Tân. Từ 3 Hợp tác xã: Quỳnh Tân, Đạt Lý, Thống Nhất, 3 tập đoàn sản xuất nông nghiệp: Phường 7, Phú Đức, TĐSX Buôn Trấp (Buôn Êcăm) gồm những người dân các tỉnh Thừa Thiên-Huế, Thái Bình, Quảng Nam."),
  /*#__PURE__*/_createElementVNode("p", null, "Sau đó rất nhiều dân từ nhiều tỉnh thành chủ yếu là miền Bắc vào lập nghiệp, các thôn có tên gọi cũng được tách ra thành các thôn mới như: Quỳnh Tân tách thành các thôn Quỳnh Tân 1, Quỳnh Tân 2, Quỳnh Tân 3, Đạt Lý tách thành các tổ dân phố 1, 2, 3, Phú Đức tách thành tổ dân phố 4, 5, ngoài ra còn có tổ dân phố Buôn Trấp, buôn Ê Căm, buôn Rung."),
  /*#__PURE__*/_createElementVNode("h3", null, "Văn hóa"),
  /*#__PURE__*/_createElementVNode("p", null, "Ngoài người Kinh chiếm 80% còn có các sắc tộc, thiểu số bản địa (Ê Đê, Gia Rai...), miền núi phía Bắc (Mường, Tày, Nùng...). Hiện tại có 11 dân tộc anh em sinh sống. 3 buôn có nhà sinh hoạt cộng đồng, Buôn Trấp, buôn Ê Căm (60m²), buôn Rung. Các tôn giáo trên địa bàn gồm có Phật giáo, Công giáo, Tin lành..."),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("iframe", {
      src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31163.8106280941!2d108.01740625475561!3d12.484555686208349!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31722097b169ed37%3A0x3d7783a4016a49d5!2zQnXDtG4gVHLhuqVwLCBLcsO0bmcgQW5hIERpc3RyaWN0LCDEkOG6r2sgTOG6r2sgUHJvdmluY2UsIFZpZXRuYW0!5e0!3m2!1sen!2s!4v1640582331313!5m2!1sen!2s",
      width: "100%",
      height: "450",
      style: {"border":"0"},
      allowfullscreen: "",
      loading: "lazy"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: "ion-hide-lg-up",
        translucent: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, {
            class: "ion-hide-lg-up",
            collapse: "condense"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}